import React from 'react';
import {
  InfoContainer,
  InfoWrapper,
  InfoRow,
  Column1,
  Column2,
  TextWrapper,
  TopLine,
  Heading,
  Subtitle,
  BtnWrap,
  ImgWrap,
  Img,
  BtnLink
} from './SupportElements';
import support from '../../images/support.jpg';

const SupportSection = () => {
  return (
    <>
      <InfoContainer $lightBg={true}>
        <InfoWrapper>
          <InfoRow $imgStart={false}>
            <Column1>
              <TextWrapper>
                <TopLine>Contact Us</TopLine>
                <Heading $lightText={false}>Need Help or Have a Question?</Heading>
                <Subtitle $darkText={true}>We're here to help. If you have any questions or need support, feel free to email us at contact@storieswefeel.com</Subtitle>
              </TextWrapper>
            </Column1>
            <Column2>
              <ImgWrap>
                <Img src={support} alt={'email'} />
              </ImgWrap>
            </Column2>
          </InfoRow>
        </InfoWrapper>
      </InfoContainer>
    </>
  );
};

export default SupportSection;
